import { useNavigate } from 'react-router-dom';
import { Controller } from 'react-hook-form';
import {
  ButtonPrimary,
  ButtonPseudo,
  ButtonType,
  IconLoader,
  InputText,
} from '@ui/src';
import { useAppDispatch } from '@store';
import { clearMfa } from '../../hoc/store/slice';
import { VerifyTwoFactorFormTypes } from './types';

import ROUTES from '../../routes';

import cn from './styles.module.css';
import sharedStyles from '../shared.module.css';

const TwoFactorForm = ({
  onSubmit,
  control,
  errors,
  requestInProgress,
  globalError,
  inputRef,
}: VerifyTwoFactorFormTypes) => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  return (
    <form className={sharedStyles.form} onSubmit={onSubmit}>
      <h3>Enter your authentication code</h3>
      {globalError && (
        <div className={sharedStyles.globalErrorMessage}>{globalError}</div>
      )}
      <fieldset className={`${sharedStyles.inputGroup} ${cn.twoFactorGroup}`}>
        <Controller
          control={control}
          defaultValue=""
          name="totpToken"
          render={({ field: { onChange, value, name } }) => (
            <InputText
              placeholder="Authentication code"
              name={name}
              value={value}
              onChange={onChange}
              error={errors?.totpToken?.message}
              disabled={requestInProgress}
              inputRef={inputRef}
              maxLength={6}
            />
          )}
        />
      </fieldset>
      <div className={sharedStyles.authButtons}>
        <ButtonPrimary
          type={ButtonType.SUBMIT}
          icon={requestInProgress ? <IconLoader /> : undefined}
          text={requestInProgress ? '' : 'Sign In'}
          bold
        />
        <ButtonPseudo
          className={sharedStyles.backButton}
          text="Back"
          onClick={() => {
            navigate(ROUTES.LOGIN_EMAIL);
            dispatch(clearMfa());
          }}
          bold
        />
      </div>
    </form>
  );
};

export default TwoFactorForm;
